export default "__VITE_ASSET__8b8ff1fd__"